import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./topServices.module.css";
import insuranceIcon from "../../assets/car-insurance.png";
import sellCarIcon from "../../assets/spinny.png";
import buyCarIcon from "../../assets/mobile-holder.png";
import historyIcon from "../../assets/cart.png";

function TopServices() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <img src={insuranceIcon} alt="Car Insurance" className={styles.icon} />,
      title: "Car Insurance",
      link: "/carInsurance",
    },
    {
      icon: <img src={sellCarIcon} alt="Sell Car" className={styles.icon} />,
      title: "Sell Car on Spinny",
      link: "https://www.spinny.com/",
    },
    {
      icon: <img src={buyCarIcon} alt="Buy Car" className={styles.icon} />,
      title: "Buy New Car",
      link: "https://www.cardekho.com/",
    },
    // {
    //   icon: <img src={historyIcon} alt="Service History" className={styles.icon} />,
    //   title: "Service History",
    //   link: "#",
    // },
  ];

  const handleCityClick = () => {
    navigate("/checkChallan");
  };

  return (
    <div className={styles.topServicesContainer}>
      <h2 className={styles.sectionTitle}>Top Services</h2>

      <div className={styles.servicesGrid}>
        {services.map((service, index) => (
          <a href={service.link} key={index} className={styles.serviceCard}>
            <div className={styles.iconWrapper}>{service.icon}</div>
            <span className={styles.serviceTitle}>{service.title}</span>
          </a>
        ))}
      </div>

      {/* <div className={styles.challanSection}>
        <h2 className={styles.challanTitle}>Check Challan Status</h2>

        <div className={styles.stateGrid}>
          <button className={styles.stateButton} onClick={handleCityClick}>Delhi</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Haryana</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Telangana</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Chhattisgarh</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Kerala</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Assam</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Uttar Pradesh</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Madhya Pradesh</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Andhra Pradesh</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Tamil Nadu</button>
          <button className={styles.stateButton} onClick={handleCityClick}>West Bengal</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Himachal Pradesh</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Maharashtra</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Rajasthan</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Gujarat</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Punjab</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Bihar</button>
          <button className={styles.stateButton} onClick={handleCityClick}>Odisha</button>
        </div>
      </div> */}
    </div>
  );
}

export default TopServices;